import { isAfter } from 'date-fns';

const isDayAfter = (day1: Date, day2: Date) =>
  isAfter(
    new Date(day1.getFullYear(), day1.getMonth(), day1.getDate()),
    new Date(day2.getFullYear(), day2.getMonth(), day2.getDate()),
  );

export { isDayAfter };
